<template>
  <div style="margin-top: 1.375rem;">
    <div>
      <h3 class="productTitle">{{ $t('meg.Product') }}</h3>
      <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">ODM Product Show</p>
    <div class="selectBox" style="margin-top: .225rem;text-align: left;">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('meg.productName')">
          <el-input  clearable v-model="productName" placeholder="请输入名称" style="width: 200px;height: 38px;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('meg.producttype')">
          <el-select v-model="proType" class="m-2" placeholder="请选择产品类型"  clearable>
            <el-option v-for="item in arrType" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('meg.isseason')">
          <el-select v-model="isseason" class="m-2" placeholder="请选择季节类型"  clearable>
            <el-option v-for="item in arrSeason" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue" />
          </el-select> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{ $t('meg.search') }}</el-button>
          <el-button  @click="chongzhi">{{ $t('meg.reset') }}</el-button>
        </el-form-item> 
      </el-form>
    </div>
    </div>
    
    <div class="productBox">
      <li v-for="(item, index) in productData" :key="index" @click="detailsBtn(item.productId)">
        <span class="newPro1" v-if="item.isNew != 1"></span>
        <span class="newPro" v-if="item.isNew == 1">{{ $t('meg.newproduct') }}</span>
        <span class="imgBox">
          <img :src="item.productImg" alt="" style="width: 4.6375rem;height: 4.5rem;">
        </span>
        <div class="productDetail">
          <div class="leftBox">
            <span class="productName">{{ item.productName }}</span>
            <span class="productSM">{{ item.productExplain }}</span>
          </div>
          <!-- <div class="rightBox">¥ {{ item.productPrice }}</div> -->
        </div>
      </li>
    </div>
    <div style="display: flex;justify-content: center;margin-bottom: .25rem;">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryForm.pageSize" :current-page="queryForm.pageNum"  @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { productManagement, productsearch } from "@/api/home.js"
import { getDicts } from "@/api/order.js"
import { useRouter } from 'vue-router';

const color = ref('')
const proType = ref('')
const isseason = ref('')
const productName = ref('')
const arrType = ref([])
const arrSeason = ref([])
const arrcolor = ref([])
const productData = ref([])
const total = ref(0)
const queryForm = reactive({
  pageSize:8,
  pageNum:1
})
onMounted(() => {
  getList()
  productColor()
  productType()
  seasonType()
})

const productColor = () => {
  getDicts("goods_color").then(res => {
    if (res.data.code == 200) {
      arrcolor.value = res.data.data
    }
  })
}

const productType = () => {
  getDicts("product_type").then(res => {
    if (res.data.code == 200) {
      arrType.value = res.data.data
    }
  })
}

const seasonType = () => {
  getDicts("clothing_season").then(res => {
    if (res.data.code == 200) {
      arrSeason.value = res.data.data
    }
  })
}

const chongzhi = () => {
  productName.value = "",
  proType.value = "",
  isseason.value = "",
  queryForm.pageNum = 1
  onSubmit()
}

const getList = () => {
  productData.value = []
  let obj = {
    pageSize:queryForm.pageSize,
    pageNum:queryForm.pageNum,
    productName: productName.value,
    productType: proType.value,
    clothingSeason:isseason.value,
  }
  productManagement(obj).then(res => {
    if (res.data.code == 200) {
      productData.value = res.data.rows
      total.value = res.data.total
    }
  })
}

const handleCurrentChange = (val) => {
  queryForm.pageNum = val
  getList()
}

const onSubmit = () => {
  productData.value = []
  queryForm.pageNum = 1
  let obj = {
    productColour: color.value,
    productName: productName.value,
    productType: proType.value,
    clothingSeason:isseason.value,
    pageSize:queryForm.pageSize,
    pageNum:queryForm.pageNum
  }
  productsearch(obj).then(res => {
    if (res.data.code == 200) {
      productData.value = res.data.rows
      total.value = res.data.total
    }
  })
}
const router = useRouter();

const detailsBtn = (productId) => {
  router.push({ path: '/productdetails', query: { productId: productId } })
}
</script>

<style scoped>
.productTitle {
  /* margin-left: 360px;  */
  font-size: .3rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  /* margin-top: 1.5rem; */
}

.trends {
  height: 3.5rem;
  background: url("../../assets/img/news_bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: left;
  padding-left: 4.5rem;
  padding-top: 1.175rem;
}


.clothesBox li {
  width: 4.2375rem;
}

.imgbox {
  width: 4.825rem;
  height: 4.825rem;
}

.productSM {
  font-size: .175rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #818AA0;
  margin-top: .3rem;
  text-align: left;
}

.productBox {
  margin-top: .375rem;
  box-sizing: border-box;
  display: flex;
  gap: .1rem;
  flex-wrap: wrap;
  padding-bottom: .75rem;
}

.productBox li {
  width: 24.5%;
  /* height: 592px; */
  background: #F6F6F6;
  opacity: 1;
}

.newPro {
  display: block;
  width: 1.25rem;
  height: .3rem;
  border-radius: .375rem .375rem .375rem .375rem;
  opacity: 1;
  border: .0125rem solid #D8D8D8;
  margin-left: .3375rem;
  margin-top: .2rem;
  line-height: .3rem;
  font-size: .2rem;
}

.newPro1 {
  display: block;
  width: 1.25rem;
  height: .3rem;
  border-radius: .375rem .375rem .375rem .375rem;
  opacity: 1;
  /* border: 1px solid #D8D8D8; */
  margin-left: .3375rem;
  margin-top: .2rem;
  line-height: .3rem;
}

.imgBox {
  margin-top: .2  5rem;
  display: inline-block;
}

.productDetail {
  height: 1.5rem;
  background: #e8e8e8;
  /* opacity: 0.06; */
  display: flex;
  justify-content: space-between;
  padding-bottom: .25rem
}

.productName {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #002FA7;

}

.productSM {
    font-size: .175rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #818AA0;
    margin-top: .125rem;
    text-align: justify;
}

.leftBox {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: .25rem;
    margin-top: .1875rem;
    padding-right: 0.125rem;
}

.rightBox {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-right: .4625rem;
    margin-top: .3875rem;
}


.rightBox {
  font-size: .2rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-right: .4625rem;
  margin-top: .3875rem;
}

.page {
  font-size: .2rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-top: .5rem;
}

.moreProduct {
  width: 7.9rem;
  height: .825rem;
  background: #FFFFFF;
  opacity: 1;
  border: .0125rem solid #000000;
  font-size: .2rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  margin: .425rem auto;
  line-height: .825rem;
  cursor: pointer;
}

::v-deep .el-form-item__label {
  font-size: .175rem;
  font-weight: 700;
}
</style>
  